const callable = (value) => /^\+?[0-9]{6,15}$/.test(value || "");

export const contactHref = (contact) => {
  if (contact.type === "email") return `mailto:${contact.value}`;
  if (!callable(contact.value)) return null;
  if (contact.type === "whatsapp") return `https://wa.me/${contact.value.replace(/\D/g, "")}`;
  return `tel:${contact.value}`;
};

export const primaryContactAction = (venue) => {
  const contacts = (venue?.contacts || []).filter((contact) =>
    ["phone", "whatsapp"].includes(contact.type) && contactHref(contact));
  const priority = (contact) => contact.source === "Google Maps" ? 0
    : contact.type === "phone" && contact.source === "Sito" ? 1
      : contact.type === "whatsapp" ? 2
        : contact.type === "phone" && contact.source?.startsWith("Instagram") ? 3 : 4;
  contacts.sort((a, b) => priority(a) - priority(b));
  if (contacts.length) return { href: contactHref(contacts[0]),
    label: contacts[0].type === "whatsapp" ? "Apri WhatsApp" : "Chiama",
    source: contacts[0].source, value: contacts[0].value,
    display: contacts[0].display || contacts[0].value, type: contacts[0].type };
  const fallback = (venue?.contact_phone || venue?.phone || "").replace(/[^\d+]/g, "");
  return callable(fallback) ? { href: `tel:${fallback}`, label: "Chiama", source: "CRM",
    value: fallback, display: venue?.contact_phone || venue?.phone, type: "phone" } : null;
};